export const DEFAULT_CORE_TAG_NAME = "Core";
export const DEFAULT_DESIGN_SYSTEM_NAME = "design system";
